import React, { useEffect, useState } from 'react';
import { useTable, usePagination } from 'react-table';
import './farmdata.css';

const Factory = () => {
  const [groupedData, setGroupedData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://kmtea.onrender.com/factory');
        if (!response.ok) throw new Error('Failed to fetch data');
        const result = await response.json();

        // group but do not push total rows
        const cleanedData = result.map(entry => ({
          ...entry,
        }));

        // Sort by date descending
        cleanedData.sort((a, b) => new Date(b.date) - new Date(a.date));
        setGroupedData(cleanedData);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const columns = React.useMemo(
    () => [
      { Header: 'Emp ID', accessor: 'empid' },
      {
        Header: 'Date',
        accessor: 'date',
        Cell: ({ value }) =>
          new Date(value).toLocaleDateString('en-GB').replace(/\/20/, '/'),
      },
      { Header: 'Time', accessor: 'time' },
      { Header: 'Factory Name', accessor: 'factoryname' },
      { Header: 'Quantity', accessor: 'quantity' },
      { Header: 'Water', accessor: 'water' },
      { Header: 'Stick', accessor: 'stick' },
      { Header: 'Tare', accessor: 'tare' },
      { Header: 'Net Weight', accessor: 'netweight' },
      { Header: 'Bagqty', accessor: 'bagqty' },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    nextPage,
    previousPage,
    pageOptions,
    state: { pageIndex },
  } = useTable(
    { columns, data: groupedData, initialState: { pageSize: 15 } },
    usePagination
  );

  if (loading) return <div className="factory-info-message">Loading...</div>;
  if (error) return <div className="factory-error-message">Error: {error}</div>;

  return (
    <div className="factory-wrapper">
      <h2 className="factory-heading">Factory Collection Details</h2>
      <table {...getTableProps()} className="factory-table">
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps()} key={column.id}>
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map(row => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()} key={row.id}>
                {row.cells.map(cell => (
                  <td {...cell.getCellProps()} key={cell.column.id}>
                    {cell.render('Cell')}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>

      <div className="factory-pagination">
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
          &lt;
        </button>
        <span>
          Page <strong>{pageIndex + 1}</strong> of <strong>{pageOptions.length}</strong>
        </span>
        <button onClick={() => nextPage()} disabled={!canNextPage}>
          &gt;
        </button>
      </div>
    </div>
  );
};

export default Factory;
